import { computed } from '@ember/object';
import { visibleBillingRecords } from 'client-portal/utils/billing/visible-billing-records';
import Super from './-resources';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingInvoices extends Super {
  @computed('model.[]', 'model.@each.isHiddenChannelBilled')
  get visibleRecords() {
    return visibleBillingRecords(this.model);
  }
}
